import styled, { css } from "styled-components";
import { Card } from "react-bootstrap";

export const Container = styled(Card)`
  ${({ theme }) => css`
    margin-left: auto;
    margin-right: auto;
    margin-top: 5rem;
    background-color:#F7F7F7;
    border: 0;
    }
  `}
`;

export const SimpletaxLogo = styled.img`
  ${({ theme }) => css`
    margin-top: 1%;
    margin-left: 85%;
    @media only screen and (max-width: 767px) {
      margin-left: 54.5%;
      width: 153px;
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      margin-left: 75%;
      width: 173px;
    }
  `}
`;

export const h1 = styled(Card)`
  ${({ theme }) => css`
    color: #2793d2;
    height: 120px;
    text-indent: 50px;
    border: 0;
    font-size: 225px;
    background-color: #f7f7f7;

    @media only screen and (max-width: 767px) {
      height: 100px;
      font-size: 150px;
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      height: 90px;
      font-size: 180px;
    }
  `}
`;

export const span = styled(Card)`
  ${({ theme }) => css`
    color: #2793d2;
    text-indent: 50px;
    font-size: 53px;
    height: 90px;
    border: 0;
    background-color: #f7f7f7;
  `}
  @media only screen and (max-width: 767px) {
    height: 55px;
    font-size: 35px;
  }
  @media only screen and (min-width: 768px) and (max-width: 1024px) {
    height: 30px;
    font-size: 50px;
  }
`;

export const para = styled(Card)`
  ${({ theme }) => css`
    margin: -15% 0 0 28.5%;
    border: 0;
    font-size: 25px;
    background-color: #f7f7f7;
    color: #616161;
    p {
      line-height: 2.5em;
    }

    a {
      color: #2793d2;
      font-weight: bold;
      &:hover {
        color: ${theme.colors.hoverBlue};
        text-decoration: underline;
      }
    }
    @media only screen and (max-width: 767px) {
      font-size: 20px;
      margin: 10% 0 0 15%;
    }
    @media only screen and (min-width: 768px) and (max-width: 1024px) {
      font-size: 18px;
      margin: 3% 0 0 5%;
    }
  `}
`;
